import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import RouterPage from './Pages/RouterPage';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const currentLang = i18n.language || 'en';
    document.documentElement.lang = currentLang;
    document.documentElement.dir = currentLang === 'ar' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  return (
    <div className="App">
      <RouterPage />
    </div>
  );
}

export default App;